import React from "react";
import Seo from "components/Seo";
import { getOrganizationSchema, getProfessionalServiceSchema, getWebsiteSchema } from "lib/seo";
import { useTranslation } from "lib/i18n";
import Banner from "../components/Banner";
import Body from "../components/Body";
import "../App.scss";

const Home = () => {
  const { language } = useTranslation();
  const isFrench = language === "fr";
  const title = isFrench
    ? "Développement logiciel sur mesure et conseil logiciel"
    : "Custom Software Development and Software Consulting";
  const description = isFrench
    ? "Quivio est un studio de développement logiciel sur mesure et de conseil en Ontario, Canada. Nous concevons et livrons des produits web, mobiles et infonuagiques adaptés à votre croissance."
    : "Quivio is a custom software development and consulting studio in Ontario, Canada. We design and build tailored web, mobile, and cloud products for growing teams.";
  const serviceTypes = [
    "Custom software development",
    "Software consulting",
    "Tailored software",
    "UI/UX design",
    "Cloud solutions",
    "Mobile app development",
  ];

  return (
    <>
      <Seo
        title={title}
        description={description}
        path="/"
        schema={[
          getOrganizationSchema(description),
          getWebsiteSchema(),
          getProfessionalServiceSchema({ description, serviceTypes }),
        ]}
      />
      <Banner />
      <Body />
    </>
  );
};

export default Home;
